angular.module('impactx.basketLink').controller('PriceCtrl', ['$scope', 'TranslationService',
    PriceCtrl]);

function PriceCtrl($scope, TranslationService){
    $scope.fictionalPriceLabel = TranslationService.get("fictionalPrice");
}